import { useGetAutomations } from "hooks/useGetAutomations";
import { AutomationCard } from "./AutomationCard";
import { Automation, automationsService } from "services/admin/automationsService";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { FaInfoCircle } from "react-icons/fa";
import { FaFire } from "react-icons/fa6";

// @deprecated
// TODO: Remove this page
export const Automations = () => {
  const { data, isLoading, error } = useGetAutomations();
  const [isAddAutomationDialogOpen, setIsAddAutomationDialogOpen] = useState(false);
  const navigate = useNavigate();
  const { id: agentID } = useParams();
  const {
    register,
    handleSubmit,
    watch,
    formState: { isValid, errors },
    reset,
  } = useForm({
    defaultValues: {
      name: "",
      agentID: agentID,
    },
    mode: "onChange",
  });

  const buildContent = () => {
    if (isLoading) {
      return <CircularProgress />;
    }
    if (error) {
      return <div>Error: {error.message}</div>;
    }
    if (data?.rows.length === 0) {
      return (
        <div
          className="text-center text-gray-500 dark:text-white p-4"
          style={{
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            maxWidth: "600px",
            margin: "0 auto",
            marginTop: "100px",
            padding: "20px",
          }}
        >
          <div>
            <strong>Автоматизация</strong> — это воронка продаж, настроенный сценарий, который бот
            выполняет автоматически, чтобы взаимодействовать с пользователями, направлять их по
            нужному пути, собирать информацию, генерировать лиды и вести к совершению целевого
            действия (например, покупке).
          </div>
          <div className="mt-4">
            <Button
              variant="outlined"
              color="primary"
              onClick={() => setIsAddAutomationDialogOpen(true)}
              className="mt-4"
              startIcon={<FaFire size={16} />}
            >
              Создать автоматизацию
            </Button>
          </div>
        </div>
      );
    }
    return data?.rows.map((automation: Automation) => (
      <div key={automation.id} className="mb-4">
        <AutomationCard automation={automation} />
      </div>
    ));
  };

  const onSubmit = async (formInput: any) => {
    try {
      if (!isValid) {
        toast.error("Пожалуйста, заполните все поля");
        return;
      }
      const createdAutomation = await automationsService.createAutomation(formInput);
      // Закрываем диалог
      setIsAddAutomationDialogOpen(false);
      // Очищаем форму
      reset();
      toast.success("Автоматизация создана успешно");

      setTimeout(() => {
        navigate(`/admin/ai-agents/${agentID}/automations/flow/${createdAutomation.id}`);
      }, 1500);
    } catch (error) {
      console.error("Error creating automation", error);
      toast.error("Ошибка при создании автоматизации");
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <div className="flex items-center gap-2">
          <div className="text-sm font-bold md:text-lg">Автоматизация</div>
          <Tooltip title="Автоматизация — это воронка продаж, настроенный сценарий, который бот выполняет автоматически, чтобы взаимодействовать с пользователями, направлять их по нужному пути, собирать информацию, генерировать лиды и вести к совершению целевого действия (например, покупке).">
            <IconButton size="small">
              <FaInfoCircle size={16} />
            </IconButton>
          </Tooltip>
        </div>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setIsAddAutomationDialogOpen(true)}
          startIcon={<FaFire size={16} />}
        >
          Создать автоматизацию
        </Button>
      </div>
      <div className="">{buildContent()}</div>
      <Dialog
        maxWidth="sm"
        fullWidth
        open={isAddAutomationDialogOpen}
        onClose={() => setIsAddAutomationDialogOpen(false)}
      >
        <DialogTitle>Создание автоматизации</DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mb-4 mt-2">
              <TextField label="Название" fullWidth required {...register("name")} />
              {errors.name && <span className="text-red-500">{errors.name.message}</span>}
            </div>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={!isValid}>
              Создать
            </Button>
          </form>
        </DialogContent>
      </Dialog>
      {/* <pre>{JSON.stringify(watch(), null, 4)}</pre> */}
    </div>
  );
};
